var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { getJson } from './request';
import { PLANS, SUBSCRIPTION_STATUS } from './constants';
const parseToken = (x) => {
    try {
        const temp = JSON.parse(atob(x.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!!window.Userback) {
            window.Userback.user_data = { 'id': temp.id, 'info': { 'name': temp.firstname, 'email': temp.email } };
        }
        return Object.assign(Object.assign({}, temp), { 'iso': temp.iso && JSON.parse(temp.iso), 'merchant': temp.merchant && JSON.parse(temp.merchant), 'isos': temp.isos && JSON.parse(temp.isos), 'merchants': temp.merchants && JSON.parse(temp.merchants) });
    }
    catch (_a) {
        if (!!window.Userback) {
            window.Userback.user_data = undefined;
        }
        localStorage.removeItem('token');
        return null;
    }
};
const readToken = (x) => !!x ? parseToken(x) : null;
let _token = readToken(localStorage.getItem('token'));
const listenersToken = new Set();
const setToken = (x) => {
    _token = readToken(x);
    listenersToken.forEach((e) => e());
    return _token;
};
const setStorage = (x) => {
    if (x === null) {
        localStorage.removeItem('token');
    }
    else {
        localStorage.setItem('token', x);
    }
    return setToken(x);
};
let storageListenerAttached = false;
const onStorage = (e) => {
    if (e.storageArea === localStorage && e.key === 'token') {
        setToken(e.newValue);
    }
};
export const useToken = () => {
    if (!storageListenerAttached) {
        window.addEventListener('storage', onStorage);
        storageListenerAttached = true;
    }
    const value = React.useSyncExternalStore((cb) => {
        listenersToken.add(cb);
        return () => listenersToken.delete(cb);
    }, () => _token);
    return value;
};
export const withToken = () => {
    const token = useToken();
    return [token, setStorage];
};
export const requireToken = (x) => {
    const [token] = withToken();
    if (token === null) {
        throw 'requireToken';
    }
    if (x === 'merchant') {
        if (!token.merchant) {
            throw 'requireToken.merchant';
        }
        else {
            return token;
        }
    }
    else {
        return token;
    }
};
/* screen */
let _screen = '#/';
const listenersScreen = new Set();
const f = () => {
    _screen = window.location.hash;
    listenersScreen.forEach((e) => e());
};
window.addEventListener('hashchange', f);
f();
export const useScreen = () => {
    const value = React.useSyncExternalStore((cb) => {
        listenersScreen.add(cb);
        return () => listenersScreen.delete(cb);
    }, () => _screen);
    return value;
};
export const navigate = (x) => __awaiter(void 0, void 0, void 0, function* () {
    sessionStorage.removeItem('unsaved');
    if (x.startsWith('#')) {
        window.location.hash = x;
    }
    else {
        window.location.href = x;
    }
});
const subscriptionCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000;
const KNOWN_PLANS = new Set(Object.values(PLANS));
const narrowPlan = (s) => KNOWN_PLANS.has(s) ? s : null;
export const fetchMerchantSubscription = (merchantId_1, ...args_1) => __awaiter(void 0, [merchantId_1, ...args_1], void 0, function* (merchantId, useCache = true) {
    var _a, _b, _c;
    if (useCache) {
        const cached = subscriptionCache.get(merchantId);
        if (cached &&
            Date.now() - cached.timestamp < CACHE_DURATION &&
            cached.status !== SUBSCRIPTION_STATUS.PendingPaymentCreate) {
            return cached;
        }
    }
    try {
        const response = yield getJson(`/merchants/${merchantId}/subscriptions`);
        const hasSubscription = (response === null || response === void 0 ? void 0 : response.status) !== SUBSCRIPTION_STATUS.Cancelled &&
            (response === null || response === void 0 ? void 0 : response.status) !== SUBSCRIPTION_STATUS.PendingPaymentCreate;
        const r = response;
        const subscription = Object.assign(Object.assign({}, response), { status: response === null || response === void 0 ? void 0 : response.status, subscription_plan: narrowPlan(response === null || response === void 0 ? void 0 : response.subscription_plan), cancel_date: response.cancel_date, is_cancelling: response.is_cancelling, is_updating: response.is_updating, new_plan: narrowPlan(response.new_plan), new_plan_effective_date: response.new_plan_effective_date, include_website: (_a = r.include_website) !== null && _a !== void 0 ? _a : false, new_include_website: (_b = r.new_include_website) !== null && _b !== void 0 ? _b : null, desired_domain: (_c = r.desired_domain) !== null && _c !== void 0 ? _c : '', has_subscription: hasSubscription, created: r.created, timestamp: Date.now() });
        subscriptionCache.set(merchantId, subscription);
        return subscription;
    }
    catch (_d) {
        const cached = subscriptionCache.get(merchantId);
        if (cached)
            return cached;
        return {
            status: '',
            subscription_plan: null,
            cancel_date: '',
            is_cancelling: false,
            has_subscription: false,
            is_updating: false,
            new_plan: null,
            new_plan_effective_date: '',
            include_website: false,
            new_include_website: null,
            desired_domain: '',
            timestamp: 0,
        };
    }
});
export const clearSubscriptionCache = (merchantId) => {
    if (merchantId) {
        subscriptionCache.delete(merchantId);
    }
    else {
        subscriptionCache.clear();
    }
};
